import { BaseButton, BaseButtonProps } from './BaseButton'

export const BigBaseButton = ({ style, ...props }: BaseButtonProps) => {
	return <BaseButton {...props} style={{ height: 56, ...style }} />
}
